import { graphql, useStaticQuery } from "gatsby";
import { getImage } from "gatsby-plugin-image";
import { ImagesQuery } from "../types";

const useImage = (name: string) => {
  const {
    allFile: { edges },
  }: ImagesQuery = useStaticQuery(graphql`
    query {
      allFile(
        filter: {
          sourceInstanceName: { eq: "images" }
          extension: { nin: ["svg", "ts"], in: ["png", "jpg", "jpeg"] }
        }
      ) {
        edges {
          node {
            name
            publicURL
            image: childImageSharp {
              gatsbyImageData(placeholder: BLURRED, layout: CONSTRAINED)
            }
          }
        }
      }
    }
  `);

  const imageToShow = getImage(
    edges.find((edge) => edge.node.name === name)?.node.image.gatsbyImageData ??
      null
  );

  return imageToShow;
};

export default useImage;
